import moment from "moment";
import { capitalize } from "../../../components/helpers";
import { convertStatus } from "./convertStatus";

export const convertDataExclusive = (data) => {
    let converted = [];

    if (!data) return [];

    data.forEach((item, index) => {
        converted.push({
            id: item.id,
            key: index + 1,
            date: moment(item.gadai_at).format('DD/MM/YYYY HH:mm'),
            customerName: capitalize(item.ktp_name),
            phone: item.phone_1,
            officerName: `${item.assigned_employee_first_name} ${item.assigned_employee_last_name}`,
            status: convertStatus(item.status),
            sbgCode: item.sbg_code,
            nik: item.ktp_number,
            address: item.address,
        });
    });
    return converted;
};
